export default "__VITE_ASSET__3RDasfJP__"